import React from "react";
import {
  MessageSquare,
  Compass,
  UserPlus,
  Moon,
  Send,
  Settings2,
} from "lucide-react";

const items = [
  {
    icon: MessageSquare,
    title: "Beantwoordt veelgestelde vragen",
    text:
      "Over prijzen, werkwijze, beschikbaarheid, timing, diensten of afspraken.",
  },
  {
    icon: Compass,
    title: "Helpt bezoekers kiezen",
    text:
      "Bezoekers worden stap voor stap naar de juiste dienst, oplossing of aanvraag geleid.",
  },
  {
    icon: UserPlus,
    title: "Verzamelt contactgegevens",
    text:
      "Naam, e-mail, telefoonnummer en de belangrijkste informatie rond hun aanvraag.",
  },
  {
    icon: Moon,
    title: "Werkt buiten kantooruren",
    text:
      "Ook 's avonds, in het weekend of wanneer uw team niet meteen kan reageren.",
  },
  {
    icon: Send,
    title: "Stuurt aanvragen door",
    text:
      "Nieuwe aanvragen kunnen overzichtelijk worden doorgestuurd naar mail of een gekozen systeem.",
  },
  {
    icon: Settings2,
    title: "Past bij uw bedrijf",
    text:
      "De chatbot wordt afgestemd op uw aanbod, tone of voice en gewenste vragenflow.",
  },
];

export const WhatItDoes = () => {
  return (
    <section id="wat-doet-het" className="relative py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.22em] font-mono-display text-[#00FFB7]">
            Wat doet het
          </span>
          <h2 className="mt-4 font-display font-semibold text-white text-3xl md:text-[42px] tracking-tight leading-[1.1]">
            Wat doet de <span className="text-gradient-neon">AI-chatbot</span> precies?
          </h2>
          <p className="mt-5 text-[#A7A7A7] text-base md:text-[17px] leading-relaxed">
            De chatbot staat op uw website en helpt bezoekers op het moment dat ze
            vragen hebben. Hij geeft duidelijke antwoorden, stelt gerichte
            vervolgvragen en verzamelt de juiste info voor opvolging.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={i}
                data-testid={`what-card-${i}`}
                className="group relative glass rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#00FFB7]/30"
              >
                <div
                  className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
                  style={{
                    background:
                      "radial-gradient(circle at 30% 0%, rgba(0,255,183,0.25), transparent 60%)",
                  }}
                />
                <div className="relative">
                  <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03]">
                    <Icon className="h-5 w-5 text-[#00EFFF]" />
                  </div>
                  <h3 className="mt-4 font-display font-semibold text-white text-lg">
                    {it.title}
                  </h3>
                  <p className="mt-1.5 text-[#A7A7A7] text-sm leading-relaxed">
                    {it.text}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatItDoes;
